module.exports = __webpack_public_path__ + "img/pintai.64ead07e.png";